var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 47.25L33.75 33.75M6.75 22.5C6.75 24.5683 7.15739 26.6164 7.9489 28.5273C8.74041 30.4381 9.90055 32.1744 11.3631 33.6369C12.8256 35.0995 14.5619 36.2596 16.4727 37.0511C18.3836 37.8426 20.4317 38.25 22.5 38.25C24.5683 38.25 26.6164 37.8426 28.5273 37.0511C30.4381 36.2596 32.1744 35.0995 33.6369 33.6369C35.0995 32.1744 36.2596 30.4381 37.0511 28.5273C37.8426 26.6164 38.25 24.5683 38.25 22.5C38.25 20.4317 37.8426 18.3836 37.0511 16.4727C36.2596 14.5619 35.0995 12.8256 33.6369 11.3631C32.1744 9.90055 30.4381 8.74041 28.5273 7.9489C26.6164 7.15739 24.5683 6.75 22.5 6.75C20.4317 6.75 18.3836 7.15739 16.4727 7.9489C14.5619 8.74041 12.8256 9.90055 11.3631 11.3631C9.90055 12.8256 8.74041 14.5619 7.9489 16.4727C7.15739 18.3836 6.75 20.4317 6.75 22.5Z",
    stroke: "#4CAF50",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11770_89916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 23.5,
    height: 23.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11770_89916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2957 17.9065C24.2957 17.2048 24.0631 16.6418 23.598 16.2175C23.1329 15.7932 22.5168 15.581 21.7498 15.581C21.2766 15.581 20.8482 15.683 20.4647 15.887C20.0812 16.091 19.7507 16.3888 19.4733 16.7805C19.2121 17.1558 18.8572 17.3721 18.4084 17.4292C17.9596 17.4863 17.572 17.368 17.2456 17.0742C17.0172 16.8621 16.8907 16.601 16.8662 16.2909C16.8417 15.9808 16.9193 15.6871 17.0988 15.4097C17.621 14.6263 18.286 14.0184 19.0938 13.586C19.9016 13.1535 20.787 12.9373 21.7498 12.9373C23.3328 12.9373 24.618 13.386 25.6053 14.2836C26.5926 15.1812 27.0863 16.3562 27.0863 17.8086C27.0863 18.543 26.9312 19.2039 26.6212 19.7914C26.3111 20.3789 25.7399 21.0725 24.9076 21.8722C24.3038 22.4433 23.8958 22.888 23.6837 23.2063C23.4715 23.5245 23.3328 23.8876 23.2675 24.2956C23.2022 24.6873 23.035 25.0136 22.7657 25.2748C22.4964 25.5359 22.1741 25.6664 21.7988 25.6664C21.4234 25.6664 21.1011 25.5399 20.8318 25.287C20.5626 25.034 20.4279 24.7199 20.4279 24.3445C20.4279 23.7081 20.5667 23.1247 20.8441 22.5943C21.1215 22.0639 21.5866 21.505 22.2394 20.9175C23.0717 20.1831 23.6225 19.616 23.8917 19.2162C24.161 18.8163 24.2957 18.3798 24.2957 17.9065ZM21.7498 31.5414C21.2113 31.5414 20.7503 31.3497 20.3667 30.9662C19.9832 30.5827 19.7915 30.1216 19.7915 29.5831C19.7915 29.0445 19.9832 28.5835 20.3667 28.2C20.7503 27.8165 21.2113 27.6248 21.7498 27.6248C22.2884 27.6248 22.7494 27.8165 23.1329 28.2C23.5164 28.5835 23.7082 29.0445 23.7082 29.5831C23.7082 30.1216 23.5164 30.5827 23.1329 30.9662C22.7494 31.3497 22.2884 31.5414 21.7498 31.5414Z",
    fill: "#4CAF50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no-result.4ce69359c6dcbbf1a1c229ead82136b7.svg";
export { ForwardRef as ReactComponent };